<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">大辛渗滤液运营管理系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              沈阳市大辛生活垃圾卫生填埋场是由沈阳市环境卫生管理处承建，常州维尔利环境服务有限公司运营的垃圾渗滤液处理项目，项目规模为1200吨/天，主要工艺路线为：MBR+NF+RO。
            </div>
            <div class="section">
              <img src="../../assets/caseDetail/weierli/1.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            大辛渗滤液运营管理系统覆盖厂区内工艺控制、设备监测、安全生产、人员管理、能耗物耗管理，借助AI智能监管、远程工控中心、智能设备监控、精细化运营管理等手段，建立了全数字化的智慧运营管理体系。
          </div>
          <div class="section">
            通过建设“少人/无人”化的智慧型工厂，实现95%以上业务线上化处理，提高80%以上任务完成效率，有效降低30%以上的运营成本。
          </div>
          <div class="section">
            系统接入了所有处置环节的生产数据，通过数据共享，关联分析，并辅以AI智能化手段控制，有效提高资源利用率，实现生产经营的精细化管理，减少70%以上的无效能耗、物耗成本。
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseWeierliDetail2.vue